import { Route, Routes } from 'react-router-dom';

import '@/pages/auth/login.css';
import { HOST_MB } from '@/lib/constants';
import { useUser } from '@/hooks/api/use-user';
import { useWhitelabelByHost } from '@/hooks/api/use-whitelabel';
import { getSession } from '@/lib/storage';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import Connection from '@/pages/auth/connection';
import GraviteeCallback from '@/pages/auth/gravitee-callback';
import NouveauMdp from '@/pages/auth/nouveau-mdp';
import OubliEmail from '@/pages/auth/oubli-email';
import OubliMdp from '@/pages/auth/oubli-mdp';

/**
 * Écrans de connexion : marque blanche de l'hôte, et utilisateur si un jeton d'iframe est en
 * session.
 */
const Login = () => {
    const token = getSession()?.token ?? null;
    const whitelabel = useWhitelabelByHost();
    const user = useUser(!!token);

    const loaded = !whitelabel.isPending && (token ? !user.isPending : true);

    const name = whitelabel.data?.name;
    const logo = whitelabel.data?.logo_light_url;

    if (!loaded) {
        return <SmallSpinner />;
    }

    document.title = `Authentification | ${name} - Espace assuré`;

    return (
        <div id={'login'}>
            {HOST_MB === 43397 && (
                <header className="flex flex-wrap fixed top-0 left-0 w-full m-0 login-header-container" style={{zIndex: 10}}>
                    <div className="flex-[1_0_0%] shadow-lg px-12 py-2 bg-white text-center">
                        <img src={logo} alt="" style={{ height: '3.5rem', width: 'auto' }} className={'inline-block'} />
                    </div>
                </header>
            )}
            <div className="flex flex-wrap m-0">
                <div className="p-0 rounded-start rounded-top rounded-medium login-picture-container hidden lg:block">
                    <img src="/images/login/image-login.jpg" alt="" className={'rounded-start rounded-top rounded-medium'} />
                </div>
                <main className="m-auto px-3 login-form-container" style={{width: '46vw'}}>
                    <div className={'m-auto login-formulaire'} style={{width: '40vw', maxWidth: 500}}>
                        <div>
                            <Routes>
                                <Route index element={<Connection />} />
                                <Route path={'callback'} element={<GraviteeCallback />} />
                                <Route path={'oubli-mot-de-passe'} element={<OubliMdp />} />
                                <Route path={'oubli-email'} element={<OubliEmail />} />
                                <Route path={'nouveau-mot-de-passe/:token'} element={<NouveauMdp />} />
                                <Route path={'nouveau-mot-de-passe'} element={<NouveauMdp />} />
                            </Routes>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Login;
